import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutes(Math.floor(Math.random() * 12) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[88px] left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-301" data-mp="115uw4dlsacu0">
      <AnimatePresence data-id="element-302" data-mp="1fv0wi4wcy93h">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_20px_50px_-12px_rgba(15,15,18,0.45)] ring-1 ring-ink/10 relative" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-303" data-mp="1axqulprs84yr">
            <img src={images.bundle} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-304" data-mp="28jeu4jjjb3ei" />
            <div className="min-w-0" data-id="element-305" data-mp="23kv4o95qf9he">
              <p className="text-[14px] leading-snug text-ink" data-id="element-306" data-mp="2aol6kj26wm5w">
                <strong data-id="element-307" data-mp="2ao1l4sdbzfn4">{buyer.name}</strong> from <strong data-id="element-308" data-mp="2fno0b7cpz5yk">{buyer.country}</strong> just purchased the Rhino Operating Playbook™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-309" data-mp="2kn0n5s3lcd15">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-310" data-mp="2plk9vuq0dsuk" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-311" data-mp="1rzwoe4v3cuxt">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-312" data-mp="26nrfxhxd4t9b" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}